<div class="dialog-content">
  <h2 matDialogTitle>Add New Category</h2>
  <mat-dialog-content>
    <form [formGroup]="categoryForm" (ngSubmit)="onSave()" novalidate class="fx-col fx-gap-20">
      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Category Name</span>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <input matInput formControlName="name" placeholder="Enter category name" required>
          <mat-error *ngIf="categoryForm.get('name')!.hasError('required')">
            Category name is required
          </mat-error>
          <mat-error *ngIf="categoryForm.get('name')!.hasError('minlength')">
            Category name must be at least 2 characters
          </mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Description (Optional)</span>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <input matInput formControlName="description" placeholder="Enter description" maxlength="500">
          <mat-hint align="end">{{categoryForm.get('description')?.value?.length || 0}}/500</mat-hint>
          <mat-error *ngIf="categoryForm.get('name')!.hasError('required')">
            Category description is required
          </mat-error>
          <mat-error *ngIf="categoryForm.get('name')!.hasError('minlength')">
            Category description must be at least 10 characters
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isLoading">
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="categoryForm.invalid || isLoading">
      {{isLoading ? 'Saving...' : 'Save Category'}}
    </button>
  </mat-dialog-actions>
</div>
